<template>
   <div>
    <div class="bodytopBox">
      <div class="bodytopBox1">
        <img src="../../../static/image/dLogo.png" class="logo" />
        <div class="bodytopBox1_1">
          <div :class='isType==i?"isTypeList":"typeList"' v-for="(item,i) in typeList" @click="selType(i)">{{item.type}}</div>
        </div>
      </div>
    </div>
    <div class="bodyBox">
      <div class="bodyBoxl">
        <div class="bodyBoxl1" v-for="(item,i) in typeList" v-if="i==isType" >{{item.type}}</div>
        <div :class='i==isType1?"bodyBoxl2":"bodyBoxl3"' v-for="(item,i) in typeList1" @click="selType1(i)" >{{item.type}}</div>
      </div>
      <div class="bodyBoxr">
        <img src="../../../static/image/1.jpg" class="aaa" />
        <img src="../../../static/image/1.jpg" class="aaa" />
        <img src="../../../static/image/1.jpg" class="aaa" />
        <img src="../../../static/image/1.jpg" class="aaa" />
      </div>
    </div>
   </div>
</template>

<script>
  export default {
    data() {
      return {
        typeList:[{type:"我的订单"},{type:"个人信息"}],
        isType:0,//typeList选中状态
        typeList1:[{type:"全部订单"},{type:"待付款"},{type:"已付款"},{type:"待使用"},{type:"待评价"},{type:"退款/售后"}],
        isType1:0,//typeList1选中状态
      }
    },
    //初始化
    created(){

    },
    methods:{
      //选择一级菜单
      selType(e){
        this.isType=e
      },
      selType1(e){
        this.isType1=e
      }
    }
  }
</script>

<style scoped>
  .bodytopBox{
    width: 100%;
    height: 100px;
    box-shadow: 0px 5px 10px #ccc;
    background-color: #FFFFFF;
  }
  .bodytopBox1{
    width: 1200px;
    height: 100px;
    display: flex;
    align-items: center;
    margin: 0px auto;
  }
  .logo{
    width: 200px;
    height: 75px;
  }
  .bodytopBox1_1{
    width: 800px;
    height: 70px;
    margin-top:30px;
    margin-left: 200px;
    display: flex;
    align-items: center;
  }
  .typeList{
    width: 120px;
    font-size: 20px;
    font-weight: 600;
    line-height: 70px;
    text-align: center;
    cursor:pointer
  }
  .isTypeList{
    width: 120px;
    font-size: 20px;
    font-weight: 600;
    line-height: 70px;
    text-align: center;
    color: #FD8723;
    cursor:pointer
  }
  .bodyBox{
    width: 1200px;
    margin: 20px auto 0px;
    display: flex;
    justify-content: space-between;
  }
  .bodyBoxl{
    width: 200px;
    border: 1px solid #CCCCCC;
    padding: 20px;
    height: 600px;
    border-radius: 5px;
  }
  .bodyBoxl1{
    width: 200px;
    height: 35px;
    line-height: 35px;
    font-size: 18px;
    font-weight: 600;
  }
  .bodyBoxl2{
    width: 180px;
    height: 35px;
    line-height: 35px;
    font-size: 16px;
    color: #FD8723;
    padding-left: 20px;
  }
  .bodyBoxl3{
    width: 180px;
    height: 35px;
    line-height: 35px;
    font-size: 16px;
    color: #333333;
    padding-left: 20px;
  }
  .bodyBoxr{
    width: 906px;
    border: 1px solid #CCCCCC;
    padding: 20px;
    height: 600px;
    margin-left: 10px;
    border-radius: 5px;
  }
  .aaa{
    width: 906px;
    height: 140px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shoppingMall/my.vue